import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private subject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

  readonly isLoading: Observable<boolean> = this.subject.asObservable();
  //   this.subject.pipe(
  //   //distinctUntilChanged(),
  //   delay(0)  // Prevents NG0100: ExpressionChangedAfterItHasBeenCheckedError
  // );

  show(): void {
    this.subject.next(true);
  }

  hide(): void {
    this.subject.next(false);
  }
}
